<template>
  <div class="enterprise-cert-query-page">
    <div class="top" v-if="isPC">
      <div></div>
      <div class="top_btn">
        <div class="btn1" @click="toBack">
          <img src="../assets/images/home1.png" alt="">
          <span>返回主页</span>
        </div>
<!--        <div class="btn2" @click="toBack1">-->
<!--          <img src="../assets/images/search1.png" alt="">-->
<!--          <span>继续查询</span>-->
<!--        </div>-->
      </div>
    </div>
    <div class="top1" v-if="!isPC">
      <div class="top_btn">
        <div class="btn1" @click="toBack">
          <img src="../assets/images/home1.png" alt="">
          <span>返回主页</span>
        </div>
<!--        <div class="btn2" @click="toBack1">-->
<!--          <img src="../assets/images/search1.png" alt="">-->
<!--          <span>继续查询</span>-->
<!--        </div>-->
      </div>
    </div>
    <!-- 主体内容区域 -->
    <div class="main-container">
      <div class="card-container">
        <div class="info-card">
          <h2 class="info-title">
            {{ name }}<br class="sm-break" /> <span style="font-size: 1.5rem">查询方式说明</span>
          </h2>
          <ul class="instructions-list">
            <li
                v-for="(item, index) in queryInstructions"
                :key="index"
                ref="instructionItems"
                class="instruction-item"
            >
              <span class="instruction-number">{{ index + 1 }}</span>
              <span class="instruction-text">{{ item.key }}</span>
            </li>
          </ul>
        </div>

        <!-- 右侧：查询表单 -->
        <div ref="rightCard" class="form-card">
          <div class="query-form">
            <div class="form-fields">
              <!-- 单位名称 -->
              <div class="form-group">
                <div class="tit">单位名称</div>
                <el-input
                    v-model="formData.name"
                    type="text"
                    class="form-input"
                />
              </div>

              <!-- 信用代码 -->
              <div class="form-group">
                <div class="tit">信用代码</div>
                <el-input
                    v-model="formData.code"
                    type="text"
                    class="form-input"
                />
              </div>

              <!-- 证书编号 -->
              <div class="form-group">
                <div class="tit">证书编号</div>
                <el-input
                    v-model="formData.number"
                    type="text"
                    class="form-input"
                />
              </div>
            </div>

            <!-- 查询按钮 -->
            <div class="submit-wrapper">
              <button type="submit" class="submit-button" @click="toSearch">点击查询</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  search_qiye,
  search_rongyu,
  search_user,
  index_config
} from "@/api/index";
export default {
  name: 'EnterpriseCertQueryPage',
  data() {
    return {
      formData: {
        type:1,
        name: '',
        code: '',
        number: ''
      },
      queryInstructions: [],
      isPC:false,
      name:'',
      type:2
    };
  },
  mounted() {
    console.log(this.$route.query)
    this.name = this.$route.query.name
    this.type = this.$route.query.type
    this.formData.type = this.$route.query.typeId
    this.getConfig()
    if (this.isMobile()) {
      this.isPC = false
    } else {
      this.isPC = true
    }
  },
  methods: {
    getConfig(){
      index_config().then(res => {
        if (res.code == 1) {
          this.queryInstructions = res.data.qiyeinfo
        }
      })
    },
    isMobile() {
      const ua = navigator.userAgent;
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    },
    toBack(){
      sessionStorage.removeItem('userInfo')
      this.$router.push({
        path: '/',
        query: { }
      })
    },
    toBack1(){
      sessionStorage.removeItem('userInfo')
      this.$router.push({
        path: '/',
        query: { index:1 }
      })
    },
    toSearch(){
      let ajax = {
        ...this.formData
      }
      if (this.type == 2) {
        search_qiye(ajax).then(res => {
          console.log(res)
          if (res.code == 1) {
            if (res.data.length == 0) {
              this.$message({
                message: '暂无查询结果',
                type: 'warning'
              })
            }else{
              sessionStorage.setItem('companyInfo',JSON.stringify(res.data))
              this.$router.push({
                path: '/qyjg',
                query: {}
              })
            }
          }else {
            this.$message({
              message: '暂无查询结果',
              type: 'warning'
            })
          }
        })
      }else if (this.type == 3) {
        search_rongyu(ajax).then(res => {
          console.log(res)
          if (res.code == 1) {
            if (res.data.length == 0) {
              this.$message({
                message: '暂无查询结果',
                type: 'warning'
              })
            }else{
              sessionStorage.setItem('companyInfo',JSON.stringify(res.data))
              this.$router.push({
                path: '/qyry',
                query: { }
              })
            }
          }else {
            this.$message({
              message: '暂无查询结果',
              type: 'warning'
            })
          }
        })
      }else if (this.type == 4) {
        search_user(ajax).then(res => {
          console.log(res)
          if (res.code == 1) {
            if (res.data.length == 0) {
              this.$message({
                message: '暂无查询结果',
                type: 'warning'
              })
            }else{
              sessionStorage.setItem('companyInfo',JSON.stringify(res.data))
              this.$router.push({
                path: '/qyhy',
                query: { }
              })
            }
          }else {
            this.$message({
              message: '暂无查询结果',
              type: 'warning'
            })
          }
        })
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.enterprise-cert-query-page {
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  background-image: url("../assets/images/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (min-width: 768px) {
    flex-direction: row;
  }

  .top {
    position: absolute;
    right: 4rem;
    top: 3rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .logo{
      cursor: pointer;
    }
  }
  .top1 {
    width: calc(100% - 40px);
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 20px;
    position: relative;
    img{
      width: 100%;
    }
  }

  .top_btn {
    display: flex;
    align-items: center;
    .btn1 {
      margin-left: 10px;
      cursor: pointer;
      display: flex;
      align-items: center;
      img{
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
    }
    .btn2 {
      margin-left: 20px;
      cursor: pointer;
      display: flex;
      align-items: center;
      img{
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
    }
  }


  .main-container {
    padding: 1rem;
    margin: 0 auto;
    @media (min-width: 768px) {
      max-width: 80rem;
      padding: 0;
    }

    .card-container {
      display: flex;
      flex-direction: column;

      @media (min-width: 768px) {
        flex-direction: row;
      }
      .info-card{
        margin-right: 0rem;
        margin-bottom: 1rem;
        @media (min-width: 768px) {
          margin-right: 3rem;
          margin-bottom: 0rem;
        }
      }

      .info-card,
      .form-card {
        width: 100%;
        background: rgba(255, 255, 255, 0.3);
        border: 1px solid rgba(255, 255, 255, 0.6);
        border-radius: 0.5rem;
        padding: 2rem 2rem;
        box-sizing: border-box;

        @media (min-width: 768px) {
          width: calc((100% - 2rem)/2);
          padding: 5rem 3rem;
        }

        .info-title {
          font-size: 1.5rem;
          font-weight: 700;
          text-align: center;
          margin-bottom: 2rem;
          color: #333333;

          @media (min-width: 768px) {
            font-size: 2rem;
            margin-bottom: 4rem;
          }

          .sm-break {
            @media (min-width: 640px) {
              display: inline;
            }
          }
        }

        .instructions-list {
          .instruction-item {
            display: flex;
            align-items: flex-start;
            margin-bottom: 2rem;
            &:last-child{
              margin-bottom: 0;
            }

            .instruction-number {
              background: rgba(255, 255, 255, 0.2);
              color: white;
              width: 1.5rem;
              height: 1.5rem;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: bold;
              font-size: 0.875rem;
              margin-right: 1rem;
            }

            .instruction-text {
              color: rgba(255, 255, 255, 0.9);
              flex: 1;
            }
          }
        }

        .query-form {
          display: flex;
          flex-direction: column;
          height: 100%;

          .form-fields {
            display: flex;
            flex-direction: column;

            .form-group {
              display: flex;
              align-items: center;
              padding: .5rem 1.5rem;
              background-color: #FFFFFF;
              border-radius: 0.375rem;
              margin-bottom: 2rem;
              @media (min-width: 768px) {
                margin-bottom: 4rem;
              }
              .tit{
                font-size: 1.1rem;
              }
              .form-label {
                color: rgba(255, 255, 255, 0.9);
                font-weight: 500;
                font-size: 1rem;
              }

              .form-input {
                flex: 1;
                color: white;
                font-size: 1rem;
              }
            }
          }

          .submit-wrapper {
            text-align: center;
            .submit-button {
              width: 16rem;
              padding: 1rem 1.5rem;
              background: #c51414;
              color: white;
              font-weight: 500;
              border: 1px solid rgba(255, 255, 255, 0.3);
              border-radius: 0.375rem;
              cursor: pointer;
              transition: all 0.3s;
              //box-shadow: 0 4px 12px rgba(30, 64, 175, 0.3);
              font-size: 1.2rem;
            }
          }
        }
      }
    }
  }
}
/deep/.el-input__inner{
  background: #FFFFFF !important;
  font-size: 18px;
  height: 44px;
  border: none;
  flex: 1;
  @media (min-width: 768px) {
    height: 54px;
  }
}
/deep/ input::placeholder {
  color: #333;
}
</style>
